import { EmbedEvent, SearchEmbed, MessagePayload } from '@thoughtspot/visual-embed-sdk'
import { useEffect } from 'react'
import { logError } from '../../services/error/logger'
import EmbeddedContent from '../../components/EmbeddedContent'
import { useOrgConfig } from '../../services/orgConfigContext/utils'
import { HIDDEN_CREATE_VISUAL_ACTIONS } from '../../constants'
import useLocationRerenderNavItem from '../../hooks/useLocationRerenderNavItem'

export const embedId = 'embed-create-visual-headcount'

/**
 * Create a Visual page accessible by the URL: /create-visual
 * This page matches the Thoughtspot 'Search Data' button under Insights
 */

const CreateVisual = () => {
  const { dataSourceGUID } = useOrgConfig()
  const locationKey = useLocationRerenderNavItem()

  useEffect(() => {
    let searchEmbed = new SearchEmbed(`#${embedId}`, {
      dataPanelV2: true,
      hiddenActions: HIDDEN_CREATE_VISUAL_ACTIONS,
    })

    if (dataSourceGUID) {
      searchEmbed = new SearchEmbed(`#${embedId}`, {
        dataSources: [dataSourceGUID],
        dataPanelV2: true,
        hiddenActions: HIDDEN_CREATE_VISUAL_ACTIONS,
      })
    }

    void searchEmbed
      .on(EmbedEvent.Error, (messagePayload: MessagePayload) => {
        const embedError = new Error(`Create a Visual: ${JSON.stringify(messagePayload)}`)
        logError(embedError)
      })
      .render()
  }, [dataSourceGUID, locationKey])

  return (
    <EmbeddedContent
      id={embedId}
      testId={embedId}
    />
  )
}

export default CreateVisual
